// ─── Gliederung eines Dokuments: nach Leistungsbereich oder wie der Betrieb ──
//
// Jede Position trägt beide Zuordnungen: gliederung = { lb, betrieb, reihenfolge }.
// Umschalten sortiert nur um — Mengen, Preise und Summen bleiben unberührt.

export const GLIEDERUNGEN = ['betrieb', 'lb'];

const andere = (modus) => (modus === 'lb' ? 'betrieb' : 'lb');

/**
 * @param gruppen  [{ name, langtext?, positionen: [{ ..., gliederung? }] }]
 * @param optionen { von, nach, texte = {} }  texte: Gruppentitel → Beschreibung
 * @returns neue Gruppen in der Gliederung `nach`, neu nummeriert
 */
export function gliedern(gruppen, { von, nach, texte = {} } = {}) {
  if (!GLIEDERUNGEN.includes(nach)) throw new Error(`Unbekannte Gliederung: ${nach}`);

  // Flach machen. Fehlt einer Position die Zuordnung zur aktuellen Gliederung
  // (z. B. von Hand ergänzt), gehört sie zu ihrer jetzigen Gruppe — so führt
  // Hin- und Zurückschalten immer zum selben Ergebnis.
  const flach = [];
  let letzte = -1;
  for (const g of gruppen || []) {
    for (const pos of g.positionen || []) {
      const gl = { ...(pos.gliederung || {}) };
      if (von && !gl[von]) gl[von] = g.name;
      if (typeof gl.reihenfolge !== 'number') gl.reihenfolge = letzte + 0.001;
      letzte = gl.reihenfolge;
      flach.push({ pos: { ...pos, gliederung: gl }, alt: g.name });
    }
  }
  flach.sort((a, b) => a.pos.gliederung.reihenfolge - b.pos.gliederung.reihenfolge);

  const neu = new Map();
  for (const { pos, alt } of flach) {
    const name = pos.gliederung[nach] || pos.gliederung[andere(nach)] || alt;
    if (!neu.has(name)) {
      const vorher = (gruppen || []).find((g) => g.name === name);
      const langtext = texte[name] ?? (nach === 'betrieb' ? vorher?.langtext ?? '' : '');
      neu.set(name, { name, ...(langtext ? { langtext } : {}), positionen: [] });
    }
    neu.get(name).positionen.push(pos);
  }

  const ergebnis = [...neu.values()];
  ergebnis.forEach((g, gi) => g.positionen.forEach((pos, pi) => { pos.nr = `${gi + 1}.${pi + 1}`; }));
  return ergebnis;
}

/** Lässt sich das Dokument überhaupt umgliedern? Nur wenn sich die Gruppen tatsächlich unterscheiden. */
export function gliederungMoeglich(gruppen) {
  const pos = (gruppen || []).flatMap((g) => g.positionen || []);
  return pos.some((p) => p.gliederung?.lb && p.gliederung?.betrieb && p.gliederung.lb !== p.gliederung.betrieb);
}
